import type { AppliedProductFilters } from '~/features/experiments/types/product-metadata.types';
import { SCOPED_IMPORT_MAX_PRODUCTS } from '~/features/onboarding/types/catalog-import.types';

/** Scoped import is Google Merchant-only today (same gating as onboarding). */
const GMC_CONNECTOR = 'GOOGLE_MERCHANT';

/** Counts filters that actually narrow the scope (drops null/''/false/empty-array),
 *  matching the filter-drawer's applied-count badge. */
export function countActiveFilters(filters: AppliedProductFilters): number {
  return Object.values(filters).filter(
    (v) => v !== null && v !== '' && v !== false && !(Array.isArray(v) && v.length === 0),
  ).length;
}

/**
 * Whether the resync action applies to the current scope — a GMC catalog narrowed
 * by filters to a scoped-import-able subset (≤ `SCOPED_IMPORT_MAX_PRODUCTS`).
 * Lives outside the button so the page can decide whether to render the actions
 * banner at all, without duplicating the visibility rule.
 */
export function isCatalogResyncVisible({
  connectorCode,
  filters,
  skuCount,
}: {
  connectorCode: string;
  filters: AppliedProductFilters;
  skuCount: number;
}): boolean {
  return (
    connectorCode === GMC_CONNECTOR &&
    countActiveFilters(filters) > 0 &&
    skuCount > 0 &&
    skuCount <= SCOPED_IMPORT_MAX_PRODUCTS
  );
}
